import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../i18n';

import { API_HOST } from '../../config/app-const';

const state = {
  carmaAiSummaries: {
    isBusy: false,
    data: [],
    error: null,
    pagination: null,
    testIsBusy: false
  }
};

const mutations = {
  LOAD_CARMA_AI_SUMMARIES_BUSY: (state, payload) => {
    state.carmaAiSummaries.isBusy = payload;
  },
  LOAD_CARMA_AI_SUMMARIES_SUCCESS: (state, payload) => {
    if (!Array.isArray(state.carmaAiSummaries.data) || payload.pagination?.currentPage === 1) {
      state.carmaAiSummaries.data = [];
    }
    state.carmaAiSummaries.data = [...(state.carmaAiSummaries.data), ...payload.data];
    state.carmaAiSummaries.pagination = payload.pagination
    state.carmaAiSummaries.error = null;
  },
  LOAD_CARMA_AI_SUMMARIES_FAIL: (state, payload) => {
    state.carmaAiSummaries.data = null;
    state.carmaAiSummaries.error = payload;
  },

  CREATE_CARMA_AI_SUMMARIES_BUSY: (state, payload) => {
    state.carmaAiSummaries.isBusy = payload;
  },
  CREATE_CARMA_AI_SUMMARIES_SUCCESS: (state, payload) => {
    state.carmaAiSummaries.data = payload;
    state.carmaAiSummaries.error = null;
  },
  CREATE_CARMA_AI_SUMMARIES_FAIL: (state, payload) => {
    state.carmaAiSummaries.data = null;
    state.carmaAiSummaries.error = payload;
  },

  UPDATE_CARMA_AI_SUMMARIES_BUSY: (state, payload) => {
    state.carmaAiSummaries.isBusy = payload;
  },
  UPDATE_CARMA_AI_SUMMARIES_SUCCESS: (state, payload) => {
    state.carmaAiSummaries.data = payload;
    state.carmaAiSummaries.error = null;
  },
  UPDATE_CARMA_AI_SUMMARIES_FAIL: (state, payload) => {
    state.carmaAiSummaries.data = null;
    state.carmaAiSummaries.error = payload;
  },

  DELETE_CARMA_AI_SUMMARIES_BUSY: (state, payload) => {
    state.carmaAiSummaries.isBusy = payload;
  },
  DELETE_CARMA_AI_SUMMARIES_SUCCESS: (state, payload) => {
    state.carmaAiSummaries.data = payload;
    state.carmaAiSummaries.error = null;
  },
  DELETE_CARMA_AI_SUMMARIES_FAIL: (state, payload) => {
    state.carmaAiSummaries.data = null;
    state.carmaAiSummaries.error = payload;
  },
  LOAD_AI_SUMMARY_TEST_BUSY: (state, payload) => {
    state.carmaAiSummaries.testIsBusy = payload;
  }
};

const actions = {
  getCarmaAiSummaries: ({ commit, rootState }, { projectId, pagination }) => {
    commit('LOAD_CARMA_AI_SUMMARIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    let query = '';
    if(pagination) {
      query = '?';
      Object.keys(pagination).map((param, i) => {
          query += `${param}=${pagination[param]}${i !== Object.keys(pagination).length - 1 ? '&' : ''}`;
        }
      );
    }

    return Axios
      .get(`${API_HOST}/projects/${projectId}/open_ai_project/ai_summaries${query}`, config)
      .then(response => {
        commit('LOAD_CARMA_AI_SUMMARIES_SUCCESS', response.data.data)
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('LOAD_CARMA_AI_SUMMARIES_FAIL', error)
      })
      .finally(() => commit('LOAD_CARMA_AI_SUMMARIES_BUSY', false));
  },

  createCarmaAiSummaries: ({ commit, rootState }, { projectId, data }) => {
    commit('CREATE_CARMA_AI_SUMMARIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .post(`${API_HOST}/projects/${projectId}/open_ai_project/ai_summaries`, 
      data,
      config)
      .then(response => {
        commit('CREATE_CARMA_AI_SUMMARIES_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.success')
        });
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: error?.response?.data?.message || i18n.t('messages.request.error')});
        commit('CREATE_CARMA_AI_SUMMARIES_FAIL', error)
      })
      .finally(() => commit('CREATE_CARMA_AI_SUMMARIES_BUSY', false));
  },

  updateCarmaAiSummaries: ({ commit, rootState }, { projectId, data }) => {
    commit('UPDATE_CARMA_AI_SUMMARIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios
      .put(`${API_HOST}/projects/${projectId}/open_ai_project/ai_summaries/${data.id}`, 
      data,
      config)
      .then(response => {
        commit('UPDATE_CARMA_AI_SUMMARIES_SUCCESS', response.data)
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.success')
        });
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: error?.response?.data?.message || i18n.t('messages.request.error')});

        console.error(error);
        commit('UPDATE_CARMA_AI_SUMMARIES_FAIL', error)
      })
      .finally(() => commit('UPDATE_CARMA_AI_SUMMARIES_BUSY', false));
  },

  deleteCarmaAiSummaries: ({ commit, rootState }, { projectId, aiSummaryId }) => {
    commit('DELETE_CARMA_AI_SUMMARIES_BUSY', true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
    };

    return Axios
    .delete(`${API_HOST}/projects/${projectId}/open_ai_project/ai_summaries/${aiSummaryId}`, 
      config)
      .then(response => {
        commit('DELETE_CARMA_AI_SUMMARIES_SUCCESS', [])
        Vue.notify({
          group: 'store_notifications',
          type: 'success',
          text: i18n.t('carma_ai.messages.delete_success')
        });
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')});

        console.error(error);
        commit('DELETE_CARMA_AI_SUMMARIES_FAIL', error)
      })
      .finally(() => commit('DELETE_CARMA_AI_SUMMARIES_BUSY', false));
  },

  runTest: ({ commit, rootState }, { projectId, data }) => {
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };
    commit('LOAD_AI_SUMMARY_TEST_BUSY', true);

    const url = `${API_HOST}/projects/${projectId}/open_ai_project/ai_summaries/test`;
    return Axios.post(url, data, config)
      .then(r => {
        return r.data.data;
      })
      .catch((error) => {
        console.error(error);
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });
      }).finally(() => commit('LOAD_AI_SUMMARY_TEST_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};